import { default as throttle } from 'lodash/throttle';
import { useMemo } from 'react';

import { AnyFunction } from '@vimeo/core/types/generic';

/**
 * Throttled callback with correctly wrapped calls.
 */
export function useThrottledCallback<T extends AnyFunction = AnyFunction>(
  callable: T,
  time: number,
  deps: Array<unknown>,
  config?: { leading?: boolean; trailing?: boolean },
) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => throttle(callable, time, config), deps);
}
